import { Box, Typography, Paper, useTheme, Divider } from "@mui/material";
import PropertyCard, { PropertyData } from "../../../components/PropertyCard";
import { SimilarProperty } from "../data/propertyData";

interface SimilarPropertiesProps {
    similar: SimilarProperty[];
}

// Función para convertir SimilarProperty a PropertyData
const convertToPropertyData = (prop: SimilarProperty): PropertyData => {
    // Parsear el address para extraer city, state y zipCode
    // Formato: "456 Lake Shore Blvd, Windermere, FL"
    const addressParts = prop.address.split(",").map((part) => part.trim());
    let streetAddress = addressParts[0] || prop.address;
    let city = "Daytona Beach";
    let state = "FL";
    let zipCode = "32118";

    if (addressParts.length >= 2) {
        // La última parte puede ser "City, ST" o "ST"
        const lastPart = addressParts[addressParts.length - 1];
        const stateMatch = lastPart.match(/^([A-Z]{2})$/);
        
        if (stateMatch) {
            // Formato: "City, ST"
            state = stateMatch[1];
            if (addressParts.length >= 3) {
                city = addressParts[addressParts.length - 2];
            }
        } else {
            // Intentar extraer "City, ST" de la última parte
            const cityStateMatch = lastPart.match(/(.+?)\s+([A-Z]{2})$/);
            if (cityStateMatch) {
                city = cityStateMatch[1].trim();
                state = cityStateMatch[2];
            } else {
                city = lastPart;
            }
        }
    }

    // Convertir sqft de string a number (ej: "3,200 sqft" -> 3200)
    const squareFeet = parseInt(prop.sqft.replace(/[^\d]/g, "")) || 0;

    return {
        id: prop.id.toString(),
        image: prop.image,
        price: prop.price,
        address: streetAddress,
        city,
        state,
        zipCode,
        beds: prop.beds,
        baths: prop.baths,
        squareFeet,
        isFeatured: false,
        isFavorite: false,
        url: prop.url || '',
    };
};

const handleViewDetails = (property: PropertyData) => {
    if (property.url) {
        window.location.href = property.url;
    }
};

export default function SimilarProperties({ similar }: SimilarPropertiesProps) {
    console.log('similar',similar)
    const theme = useTheme();

    return (
        <Paper
            elevation={2}
            sx={{
                p: { xs: 2, md: 3 },
                mt: 4,
                borderRadius: 3,
                backgroundColor: "background.paper",
                width: "100%",
            }}
        >
            {/* Header */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
                <Typography
                    variant="h5"
                    fontWeight="bold"
                    sx={{
                        color: theme.palette.primary.main,
                    }}
                >
                    Similar Properties
                </Typography>
            </Box>

            <Divider sx={{ mb: 3, borderColor: '#f8f4f0', borderBottomWidth: '2px' }} />

            {/* Properties Grid */}
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(2, 1fr)" },
                    gap: 3,
                }}
            >
                {similar.map((prop) => {
                    const propertyData = convertToPropertyData(prop);
                    return (
                        <PropertyCard
                            key={prop.id}
                            data={propertyData}
                            onViewDetails={handleViewDetails}
                            showViewDetails={true}
                            showForSale={true}
                        />
                    );
                })}
            </Box>
        </Paper>
    );
}
